import {ILccaCalculatedImperial} from "@/modules/lcca/interfaces/lccaCalculated";
import {IAlternativeResult} from "@/modules/lcca/interfaces/probabilistic";
//@ts-ignore
import {pickColors} from "@/modules/lcca/lib/pickColors.js";

var d3 = Object.assign(
  {},
  require('d3-shape'),
  require('d3-selection'),
  require('d3-axis'),
  require('d3-scale'),
  require('d3-array'),
  require('d3-drag')
);

const meanOfArray = (arr: number[]) => {
  return arr.reduce((a, b) => a + b, 0) / arr.length
}

export const createDeterministicChart = function (scenario: ILccaCalculatedImperial,
                                                  results: { [key: number]: IAlternativeResult[] }) {


  const containerdivId = 'deterministicPlotContainer';
  const targetDivId = 'deterministicPlot';
  // console.log("Creating chart in ", targetDivId, document.getElementById(targetDivId));

  interface IDeterministicResult {
    Alternative: string,
    UserCostVOC: number,
    UserCostDelay: number,
    Agency: number,
    total: number
  }

  let data: IDeterministicResult[] = [];

  let keys: string[] = [];

  // If user costs are calculated
  // if (scenario.userCostsInAnalysis) {

  // TODO: Make sure this warning gets displayed
  // if (results[0].queueLengthWarning === true) {
  //   app.renderErrorMessages('alert_error', { message: 'Warning: The queue length resulting for one or more hours exceeds the maximum queue length specified. This means that a maximum user cost will be calculated for these hours and displayed results underestimate the actual user cost. Please consider revising your traffic data or lane closure strategy (e.g. AADT, growth rate of traffic) to mitigate this issue.', httpErrors: [] });
  // }

  // Labels
  keys = ["Agency", "UserCostVOC", "UserCostDelay"];

  // Create data object
  data = Object.values(results).map(Rs => {
    const processedResult = <IDeterministicResult>{
      Alternative: Rs[0].alternative.name,
      UserCostVOC: meanOfArray(Rs.map(R => R.delayCosts)),
      UserCostDelay: meanOfArray(Rs.map(R => R.vehicleCosts)),
      Agency: meanOfArray(Rs.map(R => R.agencyCosts)),
      total: 0
    };

    if (isNaN(processedResult.UserCostVOC)){
      processedResult.UserCostVOC = 0
    }

    processedResult.total = processedResult.Agency + processedResult.UserCostDelay + processedResult.UserCostVOC

    return processedResult
  });


  // data = results.map(function (result) {
  //   return {
  //     Alternative: result.alternative.name,
  //     UserCostVOC: result.delayCosts,
  //     UserCostDelay: result.vehicleCosts,
  //     // "Detour": 0, // Need to make detour calculation
  //     Agency: result.agencyCosts,
  //     total: result.agencyCosts + result.delayCosts + result.vehicleCosts
  //   };
  // });


  // TODO: Specified user costs?
  // } else if (scenario.userCostsInAnalysis && app.data.userCostComputationMethod === "Specified") {
  // // If user costs are specified
  //   keys = ["Agency", "User"];
  //
  //   // Create data object
  //   data = results.map(function(result) {
  //     return {
  //       "Alternative": result.alternative.name,
  //       "Agency": result.agencyCosts,
  //       "User": result.userCosts
  //     };
  //   });
  //
  //   // add up total costs
  //   data.forEach(function(result) {
  //     result.total = result.Agency + result.User;
  //   });
  //
  //   // If user costs are not included
  // } else if (!scenario.userCostsInAnalysis) {
  //   keys = ["Agency"];
  //
  //   data = results.map(function (result) {
  //     return <IDeterministicResult>{
  //       Alternative: result.alternative.name,
  //       Agency: result.agencyCosts,
  //       UserCostDelay: 0,
  //       UserCostVOC: 0,
  //       total: result.agencyCosts
  //     };
  //   });
  //
  //   data = [<IDeterministicResult>{
  //     Alternative: results[0].alternative.name,
  //     UserCostVOC: 0,
  //     UserCostDelay: 0,
  //     Agency: meanOfArray(results.map(R => R.agencyCosts)),
  //     total: 0
  //   }];
  //
  //   data[0].total = data[0].Agency + data[0].UserCostDelay + data[0].UserCostVOC
  // }


  const colors = pickColors(keys.length);

  const svg = d3.select("#" + targetDivId);
  const margin = {
    upper: 30,
    right: 80,
    lower: 60,
    left: 160
  };

  //@ts-ignore
  const svgWidth = document.getElementById(containerdivId).offsetWidth;
  //@ts-ignore
  const width = document.getElementById(containerdivId).offsetWidth - (margin.right + margin.left);
  //@ts-ignore
  const height = document.getElementById(containerdivId).offsetHeight - (margin.upper + margin.lower),
    g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.upper + ")");

  const x = d3.scaleBand()
    .rangeRound([0, width])
    .paddingInner(0.05)
    .align(0.1);

  const y = d3.scaleLinear()
    .rangeRound([height, 0]);

  const z = d3.scaleOrdinal()
    .range(colors);

  data.sort(function (a, b) {
    return b.total - a.total;
  });

  x.domain(data.map(function (d: any) {
    return d.Alternative;
  }));
  y.domain([0, d3.max(data, function (d: IDeterministicResult) {
    return d.total;
  })]).nice();

  z.domain(keys);

  //Graph the costs
  g.append("g")
    .selectAll("g")
    .data(function () {
      return d3.stack().keys(keys)(data);
    })
    // group for each cost category
    .enter().append("g")
    .attr("fill", function (d: any) {
      return z(d.key);
    })
    .selectAll("rect")
    .data(function (d: any) {
      return d;
    })
    //group for each alternative
    .enter().append("rect")
    .on("mouseover", function (d: any) {
      keys.forEach(function (key) {
        g.select(".tooltip-" + key.toLowerCase()).text(key + ": " + d.data[key]);
      });
      tooltip.style("display", null);
    })
    .on("mouseout", function () {
      tooltip.style("display", "none");
    })
    .on("mousemove", function (d: any) {
      //@ts-ignore
      const xPosition = d3.mouse(this)[0] + 5;
      //@ts-ignore
      const yPosition = d3.mouse(this)[1] - 80;
      tooltip.attr("transform", "translate(" + xPosition + "," + yPosition + ")");
      keys.forEach(function (key) {
        g.select(".tooltip-" + key.toLowerCase()).text("$" + Math.round(d.data[key]));
      });
    })
    .attr("x", function (d: any) {
      return x(d.data.Alternative) + (x.bandwidth() - 50) / 2;
    })
    .attr("y", function (d: any) {
      return y(d[1]);
    })
    .attr("height", function (d: any) {
      return y(d[0]) - y(d[1]);
    })
    .attr("width", 50);

  // x axis
  g.append("g")
    .attr("class", "axis")
    .attr("transform", "translate(0," + height + ")")
    .call(d3.axisBottom(x));

  // y axis
  g.append("g")
    .attr("class", "axis")
    .call(d3.axisLeft(y));

  // y axis label
  svg.append("text")
    .style("font-size", "16px")
    .attr("font-family", "Tahoma")
    .attr("text-anchor", "middle")
    .text("Costs ($1000)")
    .attr("transform", "translate (" + margin.left / 4 + "," + (margin.upper + height / 2) + ") rotate(-90)");

  // Legend
  const legendTopMargin = 25;
  const legendLeftMargin = 20;
  const legendBoxSize = 20;
  const legendBoxMargin = 5;
  const legendTextMargin = 10;

  const legend = svg.append("g")
    .attr("text-anchor", "end")
    .style("font-size", "14px")
    .attr("font-family", "Tahoma")
    .attr("class", "legend")
    .selectAll(".legend")
    .data(keys.slice().reverse())
    .enter().append("g")
    .attr("transform", function (d: any, i: number) {
      return "translate(" + (svgWidth - legendLeftMargin) + "," + (i * (legendBoxMargin + legendBoxSize) + legendTopMargin) + ")";
    });

  legend.append("rect")
    .attr("width", legendBoxSize)
    .attr("height", legendBoxSize)
    .attr("fill", z);

  legend.append("text")
    .attr("alignment-baseline", "central")
    .attr("transform", "translate (" + (-1 * legendTextMargin) + "," + legendBoxSize * 0.5 + ")")
    .text(function (d: any) {
      let toolKey = d.split(/(?=[A-Z])/);
      toolKey = toolKey[0] + ' ' + (toolKey[1] ? toolKey[1] : '') + ' ' + '(' + toolKey[2] + (toolKey[3] ? toolKey[3] : '') + (toolKey[4] ? toolKey[4] : '') + ')';

      if (toolKey === 'Agency  (undefined)') {
        toolKey = toolKey.split(' ');
        toolKey = toolKey[0];
      }
      return toolKey;
    });

  // On hover tooltip
  const tooltip = g.append("g")
    .style("display", "none");

  tooltip.append("rect")
    .attr("width", 200)
    .attr("height", (keys.length + 1) * 15)
    .attr("fill", "white")
    .style("stroke", "black")
    .style("stroke-width", "1");

  tooltip.selectAll("text.category")
    .data(keys.slice().reverse())
    .enter().append("text")
    .attr("class", "category")
    .attr("x", 20)
    .attr("y", function (d: any, i: number) {
      return 5 + i * 15;
    })
    .attr("fill", z)
    .attr("dy", "1.2em")
    .attr("font-size", "12px")
    .attr("font-weight", "bold")
    .text(function (d: any) {
      let toolKey = d.split(/(?=[A-Z])/);
      toolKey = toolKey[0] + ' ' + (toolKey[1] ? toolKey[1] : '') + ' ' + '(' + toolKey[2] + (toolKey[3] ? toolKey[3] : '') + (toolKey[4] ? toolKey[4] : '') + ')';
      if (toolKey === 'Agency  (undefined)') {
        toolKey = toolKey.split(' ');
        toolKey = toolKey[0];
      }
      return toolKey;
    });

  tooltip.selectAll("text.quantity")
    .data(keys.slice().reverse())
    .enter().append("text")
    .attr("class", function (d: any) {
      return "quantity tooltip-" + d.toLowerCase();
    })
    .attr("x", 150)
    .attr("y", function (d: any, i: number) {
      return 5 + i * 15;
    })
    .attr("fill", z)
    .attr("dy", "1.2em")
    .attr("font-size", "12px")
    .attr("font-weight", "bold")
    .text("$0");

}
